import apiService from '../services/api';

/**
 * Track user activity for achievements and analytics
 * @param {string} activityType - The type of activity (e.g., 'how_to_play_viewed')
 * @param {string} gameId - The game identifier (e.g., 'bible-books')
 * @param {Object} activityData - Optional additional data
 * @returns {Promise<Object|null>} - Response data including any new achievements, or null if tracking failed
 */
export const trackActivity = async (activityType, gameId, activityData = null) => {
  try {
    // The apiService automatically includes credentials (cookies) with requests
    // Authentication is handled server-side - guests will get a 401 which we handle gracefully
    const response = await apiService.post('/api/user-activities', {
      activity_type: activityType,
      game_id: gameId,
      activity_data: activityData
    });

    if (response.ok) {
      const data = await response.json();
      console.log(`✓ Tracked activity: ${activityType} for ${gameId}`);
      return data;
    }
    // Silent fail for unauthenticated users (401) or other errors
    return null;
  } catch (error) {
    // Silent fail - don't disrupt user experience for tracking errors
    // This includes 401 errors for unauthenticated users
    if (error.status !== 401) {
      console.warn('Failed to track activity:', error);
    }
    return null;
  }
};

/**
 * Track when a user views a How to Play guide
 * @param {string} gameId - The game identifier
 */
export const trackHowToPlayViewed = (gameId) => {
  return trackActivity('how_to_play_viewed', gameId);
};